module.exports = __webpack_public_path__ + "static/media/about_bg.ea9dc42d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about_bg.jpg
// module id = 212
// module chunks = 0